import { api } from "../../../utils/api";

// ✅ Create Payment
export const createPayment = async (data) => {
    const res = await api.post("/finance/payments", data);
    return res.data;
};

// ✅ Upload Attachment (IMPORTANT FIXED)
export const uploadPaymentAttachment = async (id, formData) => {
    const res = await api.post(
        `/finance/payments/${id}/attachments`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return res.data;
};

// ✅ Get Payments
export const getPaymentsByInvoice = async (invoiceId, params) => {
    const res = await api.get(`/finance/invoices/${invoiceId}/payments`, {
        params,
    });
    return res.data;
};

// ✅ Download Payment
export const downloadPayment = async (id) => {
    return api.get(`/finance/payments/${id}/download`, {
        responseType: "blob",
    });
};